import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { HashLink } from 'react-router-hash-link';
import SearchInput from './SearchInput';
import Logo from './ui-elements/Logo';

import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
} from 'reactstrap';


const MenuLogo = (props) => {
  return (
    <div className="navbar-brand d-none d-sm-inline paul-nav-logo">
      <Logo style={{opacity: (props.show ? 1 : 0)}} size="sm" text={true} gray={props.path==='/search' || props.path==='/'} className="m-0" />
    </div>
  );
}


class HeaderNav extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }
  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  clickLink = (e) => {
    this.setState({
      isOpen: false
    });
  }

  render() {
    const { path } = this.props;

    let navbar_fixed = false;
    if (path==='/home' || path==='/signin' || path==='/search'){
      navbar_fixed = true;
    }

    let show_searchinput = false;
    if (path==='/search'){
    //  show_searchinput = true;
    }

    let position_class = 'position-absolute';
    if (path==='/search'){
    //  position_class = 'position-relative';
    }

    let navbar_bg_white = false;
    if (path==='/search'){
    //  navbar_bg_white = true;
    }

    let navbar_text_white = false;
    if (path==='/content'){
    //  navbar_text_white = true;
    }

    let show_logo = false;
    if (path==='/imprint'){
      show_logo = true;
    }

    let show_search_link = false;
    if (path==='/about' || path==='/content'){
      show_search_link = true;
    }

    return (
      <div id="navbarContainer" style={{ zIndex: 8000 }} className={position_class + " container-fluid px-0 " + ( navbar_fixed && ' fixed-top')  + ( navbar_bg_white && ' bg-white') + ( this.state.isOpen ? ' navbar-open':'')}>

        <Navbar color="transparent" light expand="sm" className="d-flex justify-content-between">
          { show_searchinput ?
            <div className='d-flex align-items-center py-2' style={{ minWidth: 260, maxWidth: 520, width: '100%' }}>
              <Logo size="sm" className='mr-3 mr-md-4' onClick={this.clickLink} />
              <SearchInput className="flex-grow-1"/>
            </div>
            :
            <React.Fragment>
              <MenuLogo path={path} show={show_logo} />
              <NavbarToggler onClick={this.toggle} className="border-0 ml-auto paul-nav-toggler"><i className="fas fa-bars text-secondary"></i></NavbarToggler>
            </React.Fragment>
          }
          <Collapse isOpen={this.state.isOpen} navbar>

            <Nav navbar className="ml-auto text-center">
              { show_search_link &&
              <NavItem className="px-sm-3 paul-nav-item">
                <HashLink
                  to='/#top'
                  className={ (path==='/' ? 'active ' : '') + (navbar_text_white && 'text-white') + ' nav-link font-weight-bold paul-nav-link' }
                  onClick={this.clickLink}
                ><span>Suche</span></HashLink>
              </NavItem>
              }
              <NavItem className="px-sm-3 paul-nav-item">
                <HashLink
                  to='/content#top'
                  className={ (path==='/content' ? 'active ' : '') + (navbar_text_white && 'text-white') + ' nav-link paul-nav-link' }
                  onClick={this.clickLink}
                ><span>Inhalte</span></HashLink>
              </NavItem>
              <NavItem className="px-sm-3 paul-nav-item">
                <HashLink
                  to='/about#top'
                  className={ (path==='/about' ? 'active ' : '') + (navbar_text_white && 'text-white') + ' nav-link paul-nav-link' }
                  onClick={this.clickLink}
                ><span>Über uns</span></HashLink>
              </NavItem>
              <NavItem className="px-sm-3 paul-nav-item">
                <a className={ (navbar_text_white && 'text-white') + ' nav-link paul-nav-link' } href='https://twitter.com/paulopensearch' rel="noopener noreferrer" target='_blank'><i className="fab fa-twitter" style={{ transform: 'scale(1.3)' }}></i></a>
              </NavItem>
            </Nav>

          </Collapse>
        </Navbar>

      </div>
    )
  }

}

const mapStateToProps = (state, props) => ({
  path: props.location.pathname
});

export default withRouter(connect(mapStateToProps)(HeaderNav));



// WEBPACK FOOTER //
// ./src/components/Nav.js